module.exports = new __parcel__URL__("snowman.cdcd9574.svg").toString();